export default __webpack_public_path__ + "static/media/tools-bj-bottom.38a44f7e.png";